"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCloneable = void 0;
exports.IkeCloneable = {
    ALL: 'all',
    /**
     * @default
     */
    NONE: 'none',
    FIRST: 'first',
};
//# sourceMappingURL=cloneable.js.map